import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const loginUrl = (next = window.location.pathname) => `${API}/auth/discord/login?next=${encodeURIComponent(next)}`;
export const errMsg = (e) => e?.response?.data?.detail || "صار خطأ، جرّب مرة ثانية";

export const useContent = (type) =>
  useQuery({ queryKey: ["content", type], queryFn: () => api.get(`/content/${type}`).then((r) => r.data.items) });

export const useSettings = () => useQuery({ queryKey: ["settings"], queryFn: () => api.get("/settings").then((r) => r.data) });

export const useMe = () => useQuery({ queryKey: ["me"], queryFn: () => api.get("/auth/me").then((r) => r.data.user) });

export const useServerStatus = () =>
  useQuery({ queryKey: ["status"], queryFn: () => api.get("/server-status").then((r) => r.data), refetchInterval: 30000 });
